<template>
  <div class="l-footer-panel">
    <div v-on:click="openModalBox()" class="button">
      <div class="button__inner">
        <img src="/static/img/factory/btn_service.png">
        <div class="button__newicon" v-show="isShowNewIcon">
          <span>{{ newIconNum }}</span>
        </div>
      </div>
    </div>
    <transition>
      <div v-if="isOpenBox" class="modal-box">
        <div class="modal-box__inner">
  
          <div class="modal-box__panel">
            <div class="panel">

              <div v-if="isShowList" class="panel__inner">
                <div class="panel__header">
                  Service menu
                </div>
                <div class="panel__body">
                  <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings">
                    <div class="wrapper">
                      <dl class="menu">
                        <dt class="menu__title">Automobile inspection / Checking</dt>
                        <dd class="menu__content">
                          <ul class="menu__items">
                            <li v-for="item in itemsCategory1" v-bind:key="item.id" v-on:click="openShowDetail(item.enable, 1, item.id)" v-bind:class="{disable: !item.enable}" class="item">
                              <div class="item__icon">
                                <img :src="`${staticPath}img/factory/service/icon_item_1_${item.id}_enable.png`"  v-show="item.enable">
                                <img :src="`${staticPath}img/factory/service/icon_item_1_${item.id}_disable.png`"  v-show="! item.enable">
                              </div>
                              <div class="item__title">
                                {{ item.title }}
                              </div>
                              <div class="item__star">
                                <img :src="`${staticPath}img/factory/service/star_${item.star}.png`">
                              </div>
                            </li>
                          </ul>
                        </dd>
                      </dl>
                      <dl class="menu">
                        <dt class="menu__title">Scratches and dents repairs</dt>
                        <dd class="menu__content">
                          <ul class="menu__items">
                            <li v-for="item in itemsCategory2" v-bind:key="item.id" v-on:click="openShowDetail(item.enable, 2, item.id)" v-bind:class="{disable: !item.enable}" class="item">
                              <div class="item__icon">
                                <img :src="`${staticPath}img/factory/service/icon_item_2_${item.id}_enable.png`"  v-show="item.enable">
                                <img :src="`${staticPath}img/factory/service/icon_item_2_${item.id}_disable.png`"  v-show="! item.enable">
                              </div>
                              <div class="item__title">
                                {{ item.title }}
                              </div>
                              <div class="item__star">
                                <img :src="`${staticPath}img/factory/service/star_${item.star}.png`">
                              </div>
                            </li>
                          </ul>
                        </dd>
                      </dl>
                      <dl class="menu">
                        <dt class="menu__title">Car care</dt>
                        <dd class="menu__content">
                          <ul class="menu__items">
                            <li v-for="item in itemsCategory3" v-bind:key="item.id" v-on:click="openShowDetail(item.enable, 3, item.id)" v-bind:class="{disable: !item.enable}" class="item">
                              <div class="item__icon">
                                <img :src="`${staticPath}img/factory/service/icon_item_3_${item.id}_enable.png`"  v-show="item.enable">
                                <img :src="`${staticPath}img/factory/service/icon_item_3_${item.id}_disable.png`"  v-show="! item.enable">
                              </div>
                              <div class="item__title">
                                {{ item.title }}
                              </div>
                              <div class="item__star">
                                <img :src="`${staticPath}img/factory/service/star_${item.star}.png`">
                              </div>
                            </li>
                          </ul>
                        </dd>
                      </dl>
                    </div>
                  </VuePerfectScrollbar>
                </div>
              </div>

              <transition>
                <div v-if="isShowDetail" class="panel__inner">
                  <div class="panel__header">
                    アイテム
                  </div>
                  <div class="panel__body">
                    <div class="detail">
                      <img :src="`${staticPath}img/factory/service/detail_item_${detailCategory}_${detailID}.png`">
                    </div>
                  </div>
                </div>
              </transition>

            </div>
          </div>
          <div v-on:click="onReturn()" class="modal-box__return">
            <img :src="`${staticPath}img/factory/btn_return.png`">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/service.scss';
</style>

<style lang="scss">
  @import '@/assets/scss/_scrollbar.scss';
</style>

<script>
  import Constant from '@/constant';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: 'Service',
    props: ['passedTestState'],

    components: {
      VuePerfectScrollbar
    },

    data(){
      return {
        staticPath: Constant.STATICPATH,
        isOpenBox: false,
        isShowList: true,
        isShowDetail: false,
        detailCategory: 0,
        detailID: 0,
        enableNum: 1,
        newIconNum: 0,
        isShowNewIcon: false,

        settings: {
          suppressScrollX: true,
          swipeEasing: false
        },

        itemsCategory1: [
          {
            id: 1,
            title: 'Car wash',
            star: 1,
            enable: true,
            passedTests: []
          },
          {
            id: 2,
            title: 'Free 1-month inspection for new cars',
            star: 2,
            enable: false,
            passedTests: []
          },
          {
            id: 3,
            title: 'Free 6-month inspection for new cars',
            star: 2,
            enable: false,
            passedTests: []
          },
          {
            id: 4,
            title: '12-month inspection',
            star: 2,
            enable: false,
            passedTests: [
              {
                testType: 'study',
                testId: 1
              }
            ]
          },
          {
            id: 5,
            title: '24-month inspection',
            star: 2,
            enable: false,
            passedTests: [
              {
                testType: 'study',
                testId: 2
              }
            ]
          }
        ],
        
        itemsCategory2: [
          {
            id: 1,
            title: 'Body repairs',
            star: 1,
            enable: false,
            passedTests: []
          },
          {
            id: 2,
            title: 'Flat tire repair',
            star: 2,
            enable: false,
            passedTests: []
          }
        ],

        itemsCategory3: [
          {
            id: 1,
            title: 'Smart-assist inspection',
            star: 2,
            enable: false,
            passedTests: [
              {
                testType: 'exam',
                testId: 1
              },
              {
                testType: 'exam',
                testId: 2
              }
            ]
          }
        ]
      }
    },

    methods: {

      openModalBox() {
        this.isOpenBox = true;

        this.isShowNewIcon = false;
      },

      onReturn() {

        if (this.isShowDetail) {
          this.isShowDetail = false;
          this.isShowList = true;
        } else {
          this.isOpenBox = false;
        }
      },

      openShowDetail(enable, category, id) {

        if (! enable) {
          return;
        }

        // 洗車はアイテム表示しない
        if (category == 1 && id == 1) {
          return;
        }

        this.isShowDetail = true;
        this.detailCategory = category;
        this.detailID = id;

        this.isShowList = false;
      }
    },

    watch: {

      // 合格テストリストの値を反映
      passedTestState(val) {

        let enable_num = 0;

        const passed_items = this.$store.getters['PassedTest/items'];
        const passed_num = passed_items.length;

        const checkItems = (items) => {

          const items_num = items.length;

          for (let i=0; i < items_num; i++) {

            const item = items[i];

            const item_tests = item.passedTests;
            const item_tests_num = item_tests.length;

            // テスト項目がある場合のみ
            if (item_tests_num > 0) {

              let is_enable = true;

              // アイテムの合格リストと合格テストリストとの比較
              for (let j=0; j < item_tests_num; j++) {

                const item_test = item_tests[j];            

                // 合格リストから該当項目探索
                const target_index = passed_items.findIndex((passed_item) => {
                    return (passed_item.testType === item_test.testType && 
                            passed_item.testId === item_test.testId);
                });

                // 見つからない
                if (target_index < 0) {
                  is_enable = false;
                }
              }

              items[i].enable = is_enable;
            }

            // 有効数の合計
            if (items[i].enable) {
              enable_num++;
            }
          }
        };

        // 3カテゴリ分チェック
        checkItems(this.itemsCategory1);
        checkItems(this.itemsCategory2);
        checkItems(this.itemsCategory3);

        // 有効数が最初の1件以上で値に変化があった場合
        if (enable_num > 1 && enable_num !== this.enableNum) {

          this.newIconNum = enable_num - this.enableNum;
          this.isShowNewIcon = true;

          this.enableNum = enable_num;
        }
      }
    }
  
  }
</script>



// WEBPACK FOOTER //
// src/components/Factory/Service.vue